import {
    ExamApplicationDetails,
    ExamApplicationList,
    ExamSessionDetails,
} from '../../api/ApiClient';
import { INotification } from 'components';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';

const initialState: ExamApplicationsRedux = {
    examApplicationUserAdmitted: false,
    examApplicationDetails: null,
    examApplicationsList: null,
    examSessionDetails: null,
    finalizeApplicationsList: null,
};

const examApplications = createModel({
    state: initialState,
    reducers: {
        setAdmitted(state, examApplicationUserAdmitted: boolean): ExamApplicationsRedux {
            return { ...(state || {}), examApplicationUserAdmitted };
        },
        setDetails(state, examApplicationDetails: ExamApplicationsRedux['examApplicationDetails']): ExamApplicationsRedux {
            return { ...(state || {}), examApplicationDetails };
        },
        setList(state, examApplicationsList: ExamApplicationList): ExamApplicationsRedux {
            return { ...(state || {}), examApplicationsList };
        },
        setSessionDetails(state, examSessionDetails: ExamApplicationsRedux['examSessionDetails']): ExamApplicationsRedux {
            return { ...(state || {}), examSessionDetails };
        },
        setFinalizeApplicationList(state, finalizeApplicationsList: ExamApplicationsRedux['finalizeApplicationsList']): ExamApplicationsRedux {
            return { ...(state || {}), finalizeApplicationsList };
        },
        clearExamApplications(state) {
            return { ...state, ...initialState };
        },
    },
    effects: (dispatch: any) => ({
        async fetchExamApplications(payload: FetchExamApplicationsDetails) {
            const examApplicationsList = await apiConnector.execApi(dispatch, api => api.getExamApplications(
                payload.examId,
                payload.searchField,
                payload.searchTerm,
                payload.page,
                payload.pageSize || 100,
                payload.sortOrder,
                payload.sortField,
            ));

            this.setList(examApplicationsList);
        },
        async fetchExamApplicationDetails(examApplicationId: string) {
            const examApplicationDetails = await apiConnector.execApi(dispatch, api => api.getExamApplication(examApplicationId));

            this.setDetails(examApplicationDetails);

            return examApplicationDetails;
        },
        async admitToExam(examApplicationId: string) {
            const examApplicationUserAdmitted = await apiConnector.execApi(dispatch, api => api.admitToExam(examApplicationId));

            if (examApplicationUserAdmitted) {
                dispatch.notifications.addNotification([{ message: 'Соискатель успешно допущен!', appearance: 'success' }] as INotification[]);
            }

            this.setAdmitted(examApplicationUserAdmitted);
        },
        async finishPracticeDefense(examApplicationId: string) {
           await apiConnector.execApi(dispatch, api => api.finishPracticeDefense(examApplicationId));
        },
        async getExamSessionDetailsAsync(examApplicationId: string) {
            const examSessionDetails = await apiConnector.execApi(dispatch, api => api.getExamSessionDetails(examApplicationId));

            this.setSessionDetails(examSessionDetails);
        },
        async getExamApplicationsForFinalizeAsync(data: IGetExamApplicationsForFinalize) {
            const finalizeApplicationsList = await apiConnector.execApi(dispatch, api => api.getExamApplicationsForFinalize(
                data.examId,
                data.searchField,
                data.searchTerm,
                data.page,
                data.pageSize,
                data.sortOrder,
                data.sortField,
            ));

            this.setFinalizeApplicationList(finalizeApplicationsList);
        },
        async formatRecommendationsSketchAsync(examApplicationId: string) {
            const recommendationsSketch = await apiConnector.execApi(dispatch, api => api.formatRecommendationsSketch(examApplicationId));

            return recommendationsSketch;
        },
    }),
});

export default examApplications;

interface IGetExamApplicationsForFinalize {
    examId?: string | undefined;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean | undefined;
    sortField?: string;
}

interface ExamApplicationsRedux {
    examApplicationUserAdmitted: boolean;
    examApplicationDetails: ExamApplicationDetails | null;
    examApplicationsList: ExamApplicationList | null;
    examSessionDetails: ExamSessionDetails | null;
    finalizeApplicationsList: ExamApplicationList | null;
}

interface FetchExamApplicationsDetails {
    examId?: string;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}
